import { Bar } from "react-chartjs-2"; // Import de Bar au lieu de Line
import { Chart, ChartOptions, registerables } from "chart.js";
import { forwardRef } from "react";
import { cn } from "@reactive-resume/utils";

Chart.register(...registerables);

type BarChartProps = {
  className?: string;
  labels: string[];
  option?: ChartOptions<"bar">;
  data: number[];
  key: string;
  title: string;
  // Ajoutez cette prop si vous voulez mettre une barre en surbrillance (comme "Mar" sur la maquette)
  activeIndex?: number;
};

export const BarChartForQuantityByPeriode = forwardRef<HTMLDivElement, BarChartProps>(
  ({ className, labels, option, data, key, title, activeIndex }, ref) => {
    // Options adaptées pour l'histogramme
    const options: ChartOptions<"bar"> = {
      responsive: true,
      maintainAspectRatio: false, // Pour rester dans le conteneur parent
      plugins: {
        legend: {
          display: false, // Pas de légende nécessaire pour un graphique simple
        },
        title: {
          display: true,
          text: title,
          color: "var(--text-primary-admin)", // Couleur du titre
          font: { family: "Inter, sans-serif", size: 14, weight: "bold" },
        },
      },
      scales: {
        x: {
          grid: { display: false }, // Pas de lignes verticales pour un rendu plus épuré
          ticks: { color: "var(--text-muted-admin)" },
        },
        // y: {
        //     border: { display: false }, // Pas de bordure sur l'axe Y
        //     grid: { color: 'var(--border-subtle-admin)' }, // Lignes horizontales subtiles
        //     ticks: { color: 'var(--text-muted-admin)' }
        // }
      },
      ...option,
    };

    // Génération des couleurs des barres
    // Si un activeIndex est fourni, on colore cette barre avec la couleur vive (accent), sinon on utilise une couleur neutre (surface)
    const backgroundColor = data.map((_, index) =>
      activeIndex === index ? "hsl(245 70% 60%)" : "hsl(220 13% 22%)",
    );

    const dataForChart = {
      labels: labels,
      datasets: [
        {
          label: title,
          data: data,
          backgroundColor: backgroundColor,
          borderColor: backgroundColor, // Bordure assortie
          borderWidth: 0,
          borderRadius: 6, // Coins arrondis en haut des barres
          borderSkipped: false, // Permet d'arrondir les 4 coins (sinon seul le haut est arrondi)
          barPercentage: 0.5, // Largeur des barres (50% de l'espace disponible)
          categoryPercentage: 0.6, // Espacement entre les barres
        },
      ],
    };

    return (
      <div ref={ref} className={cn("h-64 w-full", className)}>
        <Bar key={key} options={options} data={dataForChart} />
      </div>
    );
  },
);

BarChartForQuantityByPeriode.displayName = "BarChartForQuantityByPeriode";
